import { render, staticRenderFns } from "./Gradient.vue?vue&type=template&id=5b2f3a9e&"
import script from "./Gradient.vue?vue&type=script&lang=ts&"
export * from "./Gradient.vue?vue&type=script&lang=ts&"
import style0 from "./Gradient.vue?vue&type=style&index=0&id=5b2f3a9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports